(function () {

  const product_slider_v1_list = document.querySelectorAll('.js_product_slider_v1')

  if (product_slider_v1_list.length > 0) {
    for (let i = 0; i < product_slider_v1_list.length; i++) {
      const slider = product_slider_v1_list[i]
      initProductSliderV1(slider)
      breakTitle(slider)
      handleEqualHeightOnContentElements(slider);
    }
  }

  function slidesCalc({mobil = 1, tablet = 1, desktop = 1, totalSlides = 1} = {}) {

    let mobileLoop = false;
    let tabletLoop = false
    let desktopLoop = false
    let mobileSlidesPerView = 1
    let tabletSlidesPerView = 1
    let desktopSlidesPerView = 1


    // If set number of slides per view is less than total number of slides, there are enough slides to loop them without duplicating
    // Set slides per view if not enough slides to loop. Problem example: for totalSlides = 2 & desktopSlidesPerView = 3 : slider will look weird (not align to center)
    if (mobil < totalSlides) {
      mobileLoop = true
    } else {
      mobileSlidesPerView = totalSlides
    }
    if (tablet < tabletLoop) {
      tabletLoop = true
    } else {
      tabletSlidesPerView = totalSlides
    }
    if (desktop < totalSlides) {
      desktopLoop = true
    } else {
      desktopSlidesPerView = totalSlides
    }

    return {mobileLoop, tabletLoop, desktopLoop, mobileSlidesPerView, tabletSlidesPerView, desktopSlidesPerView};

  }

  function totalOriginalSlides(slider) {
    // Number of slides without duplicates - must be run before swiper init
    return slider.querySelectorAll('.swiper-slide').length;
  }


  function initProductSliderV1(slider) {

    // Set desired slidesPerView for mobil, tablet & desktop
    const slidesCalcOption = slidesCalc({mobil: 1, tablet: 3, desktop: 3, totalSlides: totalOriginalSlides(slider)});


    let sliderOptions = {

      spaceBetween: 40,
      slidesPerView: slidesCalcOption.mobileSlidesPerView,
      centeredSlides: slidesCalcOption.mobileLoop,
      loop: slidesCalcOption.mobileLoop,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 992px
        992: {
          loop: slidesCalcOption.tabletLoop,
          centeredSlides: slidesCalcOption.tabletLoop,
          slidesPerView: slidesCalcOption.tabletSlidesPerView,
          spaceBetween: 20
        },
        // when window width is >= 1200px
        1200: {
          loop: slidesCalcOption.desktopLoop,
          centeredSlides: slidesCalcOption.desktopLoop,
          slidesPerView: slidesCalcOption.desktopSlidesPerView,
          spaceBetween: 40,
        }
      },
      pagination: {
        el: '.js_product_slider_v1_pagination .swiper-pagination',
        clickable: true,
        // dynamicBullets: true,
      },
      navigation: {
        nextEl: '.js_product_slider_v1_nav .swiper-button-next',
        prevEl: '.js_product_slider_v1_nav .swiper-button-prev',
      },
    }

    new Swiper(slider, sliderOptions)
  }

  function handleEqualHeightOnContentElements(slider) {
    const _contents = slider.querySelectorAll('.slide-card__footer .inner');
    if (window.innerWidth > 767) {
      setEqualHeightOnContentElements(_contents);

      window.addEventListener('resize', () => setEqualHeightOnContentElements(_contents));

    } else {
      _contents.forEach((content) => {
        content.children[0].style.height = 'initial';
        content.children[1].style.height = 'initial';
      });
    }
  }

  function setEqualHeightOnContentElements(contents) {
    if (contents) {

      let _titleMaxHeight = 0;
      let _textMaxHeight = 0;

      contents.forEach((content) => {
        // content.children[0].style.height = ''; // Reset the height before calculating
        // content.children[1].style.height = ''; // Reset the height before calculating

        _titleMaxHeight = getElementMaxHeight(content.children[0].children[0], _titleMaxHeight);
        _textMaxHeight = getElementMaxHeight(content.children[1].children[0], _textMaxHeight);
      });

      contents.forEach((content) => {
        content.children[0].style.height = _titleMaxHeight + 'px';
        content.children[1].style.height = _textMaxHeight + 'px';
      });

    }
  }

  function getElementMaxHeight(el, elMaxHeight) {
    if (el.clientHeight > elMaxHeight) {
      elMaxHeight = el.clientHeight;
    }

    return elMaxHeight;
  }

  function breakTitle(slider) {
    const sliderItems = slider.querySelectorAll(".slide-card__title");

    sliderItems.forEach(item => {
      const originalHtml = item.innerHTML;
      const firstWord = originalHtml.replace(/^\s+/, '').split(' ')[0];
      const remainingContent = originalHtml.slice(firstWord.length + 1);
      item.innerHTML = `${firstWord}</br>${remainingContent}`;
    });
  }

})()
